import useLoginPopup from "../../../hooks/useLoginPopup"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"
import { useTrack } from "@hackler/react-sdk"
import { Button, Grid, Typography } from "@material-ui/core"
import { GAEvent } from "../../../modules/GoogleAnalytics"
import { FormattedMessage } from "react-intl"
import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import backgroundImg from "../../../assets/images/analytics/analytics_main.png"
import backgroundImgMo from "../../../assets/images/analytics/analytics_main_mo.png"
import useScrollImpressionLog from "../../../hooks/useScrollImpressionLog"

interface StyleProps {
  isMobile: boolean
}
const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#FFF",
      backgroundImage: ({ isMobile }) => `url(${isMobile ? backgroundImgMo : backgroundImg})`,
      backgroundSize: "auto 100%",
      padding: "40px 0 148px",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center bottom",
      height: 430,
      [theme.breakpoints.up("md")]: {
        height: 560,
        padding: "117px 0",
      },
    },
    titleContainer: {
      marginBottom: 12,
    },
    title: {
      fontSize: 24,
      lineHeight: "140%",
      color: "rgba(0, 0, 0, .87)",
      letterSpacing: -1,
      [theme.breakpoints.up("md")]: {
        fontSize: 56,
      },
    },
    description: {
      marginBottom: 40,
      "& h5": {
        fontSize: 14,
      },
      [theme.breakpoints.up("md")]: {
        "& h5": {
          fontSize: 24,
        },
      },
    },
    buttonWrapper: {
      marginBottom: 40,
      [theme.breakpoints.up("md")]: {
        marginBottom: 74,
      },
    },
    button: {
      borderRadius: 8,
      textTransform: "none",
      color: theme.palette.common.white,
      padding: "8px 16px",
      fontSize: 14,
      [theme.breakpoints.up("md")]: {
        padding: "12px 20px",
        fontSize: 20,
      },
    },
    bottomGradient: {
      marginTop: "20%",
      width: "100%",
      height: 1265,
      background: "linear-gradient(180deg, #FAFCFF 21%, rgba(179, 212, 255, 0) 84.33%)",
    },
  })
)

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL
export default function MainVisual() {
  const loginPopup = useLoginPopup()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  const track = useTrack()
  const classes = useStyles({ isMobile })
  const { ref } = useScrollImpressionLog({
    message: "1_0: 누구나 쉽게 데이터 분석 가능",
    eventKey: "homepage_data_analytics_detail_section_1_impression",
  })

  return (
    <div className={classes.root} ref={ref}>
      <Grid container style={{ textAlign: "center" }}>
        <Grid item xs={12} className={classes.titleContainer}>
          {lang === "ko" ? (
            <strong className={classes.title}>
              누구나 쉽게
              <br />
              원하는 데이터를 {isMobile && <br />}분석할 수 있습니다
            </strong>
          ) : (
            <strong className={classes.title}>Anyone can analyze data {isMobile && <br />}with ease</strong>
          )}
        </Grid>
        <Grid item xs={12} className={classes.description}>
          {lang === "ko" ? (
            <Typography variant={"h5"}>
              데이터 분석가가 아니더라도 <br />
              사용자 행동 데이터를 간편하게 설정하고 {isMobile && <br />}다양하게 분석할 수 있습니다.
            </Typography>
          ) : (
            <Typography variant={"h5"}>
              Not a data analyst? Not a problem.
              <br />
              Analyze and interpret data with intuitive clicks.
            </Typography>
          )}
        </Grid>
        <Grid className={classes.buttonWrapper} item xs={12}>
          <Button
            onClick={() => {
              track({ key: "homepage_all_data_analytics_start_click" })
              track({ key: "homepage_data_analytics_section_1_data_analytics_start_click" })
              GAEvent({
                category: "analytics-1",
                action: "click",
                label: "start analytics",
              })
              loginPopup(`${dashboardUrl}/analytics`)
            }}
            color={"primary"}
            variant={"contained"}
            className={classes.button}>
            <strong>
              <FormattedMessage id={"CTA_ANALYTICS"} />
            </strong>
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}
